import Vue from 'vue';
import {http} from '../../http';
import sortBy from 'lodash/sortBy';
import size from 'lodash/size';

export default {
    state: {
        calendars: {},
        loaded: false,
        loading: false
    },

    mutations: {
        deleteCalendar(state, calendar) {
            Vue.delete(state.calendars, calendar.id);
        },

        setCalendars(state, calendars) {
            state.calendars = calendars;
        },

        updateCalendar(state, calendar) {
            Vue.set(state.calendars, calendar.id, calendar);
        },

        updateCalendarVisibility (state, { calendarId, show }) {
            const calendar = state.calendars[calendarId]
            if (calendar) {
                calendar.user_settings[0].is_shown = show
            }
        }
    },

    getters: {
        getCalendarById: (state, getters) => (id) => {
            return state.calendars[id];
        },

        getCalendars: (state, getters) => () => {
            return sortBy(objectToArray(state.calendars), (calendar) => calendar.user_settings[0].sortorder);
        },

        getEditableCalendars: (state, getters) => () => {
            return getters.getCalendars().filter(cal => cal.can_edit);
        },

        getNumberOfCalendars: (state, getters) => () => {
            return size(state.calendars);
        },

        getActiveCalendars: (state) => {
            return Object.values(state.calendars)
                .filter((calendar) => calendar.user_settings.some((setting) => setting.is_shown))
        },

        isLoaded: (state, getters) => () => {
            return state.loaded;
        }
    },

    actions: {
        loadCalendars ({ state, dispatch }) {
            if (state.loaded || state.loading) {
                return;
            }

            dispatch('forceLoadCalendars');
        },

        forceLoadCalendars ({ state, commit }) {
            state.loading = true;

            http.get('/app/calendars')
                .then(({ data }) => {
                    commit('setCalendars', data);
                    state.loading = false;
                    state.loaded = true;
                    window.event_bus.$emit('calendarsLoaded');
                })
                .catch(() => {
                    commit('setCalendars', []);
                    state.loading = false;
                    state.loaded = false;
                });
        },

        loadData ({ dispatch }) {
            dispatch('loadCalendars');
        },

        orderCalendars ({ state, dispatch }, calendars) {
            state.loading = true;

            http.post('/app/calendar/order', calendars)
                .then(({ data }) => {
                    dispatch('forceLoadCalendars');
                    state.loading = false;
                });
        },

        updateCalendar({ state, getters, commit }, newCalendarAttributes) {
            let calendarId = newCalendarAttributes.id;
            calendar = getters['getCalendarById'](calendarId);

            if (!calendar) {
                console.error('Could not find calendar with ID ' + calendarId);
                return;
            }

            http.post(`/app/calendar/${calendar.id}`, { ...calendar, ...newCalendarAttributes })
                .then(({ data }) => {
                    commit('updateCalendar', data.calendar);
                })
                .catch(({ error }) => {
                    console.error(error);
                });
        },
    }
};

function objectToArray(obj) {
    return Object.keys(obj).map((key) => { return obj[key]; });
}
